document.addEventListener('DOMContentLoaded', function () {
	// Obtient le nom de domaine du site actuel
	const siteDomain = window.location.hostname;

	// Sélectionne tous les éléments <a> dans le document
	const links = document.querySelectorAll('a');

	// Parcourt chaque lien
	links.forEach(link => {
		const href = link.getAttribute('href');
		const linkDomain = (new URL(href, window.location)).hostname; // Crée un objet URL pour obtenir le domaine du lien

		// Vérifie si le lien est externe en comparant les domaines
		if (href && siteDomain !== linkDomain) {
			// Ajoute target="_blank" au lien externe
			link.setAttribute('target', '_blank');
			// Optionnel: Ajoute rel="noopener noreferrer" pour la sécurité
			link.setAttribute('rel', 'noopener noreferrer');
		}
	});
});
